import { Alert, AlertProps } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';

export interface SonarAlertProps extends AlertProps {
	active?: boolean;
	afterClose?: () => void;
}

export const SonarAlert: React.FC<SonarAlertProps> = ({ active, afterClose, ...otherProps }) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [ visible, setVisible ] = useState(false);

	useEffect(() => {
		if (!active) {
			const closeButton: HTMLButtonElement | null | undefined =
				containerRef.current?.querySelector('.ant-alert-close-icon');

			closeButton?.click();
		} else if (active) {
			setVisible(true);
		}
	}, [ active, containerRef ]);

	const handleAfterClose = useCallback(() => {
		setVisible(false);

		if (afterClose) {
			afterClose();
		}
	}, [ afterClose ]);

	if (!visible) {
		return null;
	}

	return (
		<div ref={ containerRef }>
			<Alert
				afterClose={ handleAfterClose }
				{ ...otherProps } />
		</div>
	);

};
